import { render } from "./Final.vue?vue&type=template&id=6e6928e8"
import script from "./Final.vue?vue&type=script&lang=ts"
export * from "./Final.vue?vue&type=script&lang=ts"
script.render = render

export default script